
import { getDict } from './index'
import store from '../store'
import {moment} from './index'

export function tenThousand(num, unit = '万'){
  return num >= 10000 ? (Math.floor(num / 1000) / 10) + unit : num
}

export function thousand(num, unit = '千'){
  return num >= 1000 ? (Math.floor(num / 100) / 10) + unit : num
}
export function million(num, unit = '百万'){
  return num >= 1000 * 1000 ? (Math.floor(num / (100 * 1000)) / 10) + unit : num
}


export function readableNum(num){
  return thousand(million(num,'M'), 'K');
  /*if(store.state.lang === 'en'){
    return thousand(num, getDict(12))
  }else{
    return tenThousand(num, getDict(12))
  }*/
}


export function formatDate(dateValue,format="YYYY/MM/DD HH:mm:ss") {
	let date = new Date(dateValue);
  return moment(date).format(format);
}

export function formatDict(value,obj) {
	if(typeof obj == 'object'){
		return value.replace(/\$\{([^\^}]*)\}/g,function(str,key){
			return obj[key.trim()] || '';
		});
	}else{
		return value.replace(/\$\{[^\}]*\}/g,obj);
	}  
}
export function i18n(value) {
	if(typeof value == 'string'){
		return value;
	}
	const lang = store.state.lang
	return value[lang] || ''
}

